module.exports = __webpack_public_path__ + "img/ch51.8e7653ae.jpg";